import { Typography } from '@mui/material';

export default function FormLabelAsterisk() {
    return (
        <Typography component="span" color="error">
            *
        </Typography>
    );
}
